export default "__VITE_PUBLIC_ASSET__b6e671ed__"